import React, { memo } from "react";
import useNotificationToolbar from "./index.hooks";
import { AppButton } from "components/index";
import {
  Hidden,
  IconButton,
  Menu,
  MenuItem,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  GridColumnsToolbarButton,
  GridFilterAltIcon,
  GridFilterListIcon,
  GridFilterToolbarButton,
  GridToolbarContainer,
} from "@material-ui/data-grid";
import TelegramIcon from "@material-ui/icons/Telegram";

type NotificationToolbarProps = {};

const NotificationToolbar = ({}: NotificationToolbarProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    handleSendNotificationDialogOpen,
    handleMenuClose,
    handleMenuOpen,
    setTypeFilter,
    anchorEl,
    filter,
    isLoading,
    data,
    t,
  } = useNotificationToolbar();

  return (
    <GridToolbarContainer>
      <Tooltip
        title={<Typography variant={"body2"}>{data.message}</Typography>}
        placement={"bottom-start"}
        disableHoverListener={!data.isDisabled}
      >
        <span>
          <AppButton
            variant="contained"
            color="primary"
            endIcon={<TelegramIcon />}
            className={styles.datagridButton}
            onClick={handleSendNotificationDialogOpen}
            disabled={isLoading || data.isDisabled}
            loading={isLoading}
          >
            {t("Invia una notifica")}
          </AppButton>
        </span>
      </Tooltip>
      <Hidden xsDown implementation="css">
        <GridColumnsToolbarButton />
      </Hidden>
      <Tooltip
        title={
          <Typography variant={"body2"}>{t("filtra tipologia")}</Typography>
        }
        placement={"bottom-start"}
      >
        <AppButton
          startIcon={<GridFilterListIcon />}
          onClick={handleMenuOpen}
          className={styles.filterButton}
        >
          {filter}
        </AppButton>
      </Tooltip>
      <Menu
        open={Boolean(anchorEl)}
        id={"type-filter"}
        onClose={handleMenuClose}
        anchorEl={anchorEl}
      >
        <MenuItem id="all" onClick={() => setTypeFilter("Tutte")}>
          {t("Tutte")}
        </MenuItem>
        <MenuItem id="test" onClick={() => setTypeFilter("Test")}>
          {t("Test")}
        </MenuItem>
        <MenuItem id="production" onClick={() => setTypeFilter("Produzione")}>
          {t("Produzione")}
        </MenuItem>
      </Menu>
    </GridToolbarContainer>
  );
};

export default memo(NotificationToolbar);
